import React from 'react';
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade';

import ActiveCampaignForm from './active-campaign-form';

const ActiveCampaignComponent = ({ content = '', formId = '' }) => {

  return (
    <section className='active-campaign-component'>
      <Fade bottom distance={'40px'}>
        <div className='active-campaign-component__inner'>
          <div className='active-campaign-component__content'>
            {content && parse(content)}
          </div>
          {formId && (
            <div className='active-campaign-component__form'>
              { <ActiveCampaignForm formId={formId} height='800px' /> }
            </div>
          )}
        </div>
      </Fade>
    </section>
  )
}

export default ActiveCampaignComponent